// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3Hxhh","left":"styles_left__1tcvW"};